import React, { FC, useLayoutEffect, useMemo } from "react";
import { FormRenderProps, useForm, useFormState } from "react-final-form";
import { Grid, Typography, makeStyles } from "@material-ui/core";
import Field from "../../../../components/Field";
import { Country, getData } from "country-list";
import Autocomplete from "../../../../components/Autocomplete";
import {
  INTERNATIONAL,
  SERVICE_TYPES_OPTIONS,
  detailsConfig,
} from "../../constants";
import { ServiceDetailType } from "../../types";
import { AccordionEditor } from "../../../program/modals/components/step4/AccordionEditor";
import DetailImages from "./DetailImages";

const useStyles = makeStyles(() => ({
  mainContainer: {
    width: "100%",
  },
  title: {
    marginTop: 8,
    marginBottom: 16,
    fontSize: 18,
    fontWeight: "bold",
    color: "#535358",
  },
}));

const Content: FC<FormRenderProps> = ({ handleSubmit }) => {
  const classes = useStyles();
  const { values } = useFormState();
  const { change } = useForm();
  const countries = useMemo((): Country[] => {
    const orderedCountries = getData()
      .sort((a, b) => (a.name > b.name ? 1 : b.name > a.name ? -1 : 0))
      .map((c) => ({ ...c, group: "All Countries" }));

    return [
      { code: INTERNATIONAL, name: "International", group: "" },
      ...orderedCountries,
    ];
  }, []);
  const selectedCountries = values.countries;
  const [expanded, setExpanded] = React.useState<ServiceDetailType>();

  const handleExpand = (panel) => (_, newExpanded) => {
    setExpanded(newExpanded ? panel.type : false);
  };

  useLayoutEffect(() => {
    if (!selectedCountries || selectedCountries.length < 2) return;

    const firstCountry = selectedCountries[0];
    const lastCountry = selectedCountries[selectedCountries.length - 1];

    if (lastCountry.code === INTERNATIONAL) {
      change("countries", [lastCountry]);
      return;
    }

    if (firstCountry.code === INTERNATIONAL) {
      change("countries", selectedCountries.slice(1));
    }
  }, [selectedCountries]);

  return (
    <form noValidate onSubmit={handleSubmit}>
      <div className={classes.mainContainer}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Field
              required
              fullWidth
              label="Service Type"
              options={SERVICE_TYPES_OPTIONS}
              placeholder="Please Select"
              name={"serviceType"}
              component={Autocomplete}
            />
          </Grid>
          <Grid item xs={12}>
            <Field
              fullWidth
              required
              type="text"
              label="Operating Countries"
              options={countries}
              groupBy={(option) => option.group}
              placeholder="Please Select"
              component={Autocomplete}
              multiple={true}
              disableCloseOnSelect={true}
              name={"countries"}
            />
          </Grid>
          <Grid item xs={12}>
            <Typography className={classes.title}>Service Details</Typography>
            {detailsConfig.map((item) => (
              <Field
                key={item.type}
                isExpanded={expanded === item.type}
                isRequired={item.isRequired}
                onExpand={() => handleExpand(item)}
                title={item.name}
                type="text"
                name={`details.type_${item.type}`}
                component={AccordionEditor}
              />
            ))}
          </Grid>
          <Grid item xs={12}>
            <DetailImages />
          </Grid>
        </Grid>
      </div>
    </form>
  );
};

export default Content;
